import React from "react";
import {Box, Card, CardHeader, CircularProgress, Typography} from "@mui/material";
import {Area, AreaChart, CartesianGrid, ReferenceLine, ResponsiveContainer, Tooltip, XAxis, YAxis} from 'recharts';
import {useSelector} from "react-redux";


export const ProgressSectionProposal = () => {

    const { proposalListByDate } = useSelector((s) => s.proposalReducer);
    const { tableLoading } = useSelector((s) => s.loading);
    const data = Array.isArray(proposalListByDate) ? proposalListByDate : [];
    const totalProposals = data.reduce((sum, item) => sum + (item.sessions || 0), 0);

    return (
        <Box sx={{ p: 3, position: 'relative' }}>
            <Card sx={{ boxShadow: 'none', borderRadius: '16px', p: 3, opacity: tableLoading ? 0.5 : 1 }}>
                <CardHeader
                    title={
                        <Box>
                            <Typography fontWeight={600} fontSize="30px">
                                Proposals Sent By Date
                            </Typography>
                            <Typography fontWeight={500} fontSize="16px" color="text.secondary" mt={1}>
                                Total: {totalProposals}
                            </Typography>
                        </Box>
                    }
                />
                <ResponsiveContainer width="100%" height={300}>
                    <AreaChart data={proposalListByDate} margin={{ top: 10, right: 30, left: 0, bottom: 0 }}>
                        <defs>
                            <linearGradient id="colorSessions" x1="0" y1="0" x2="0" y2="1">
                                <stop offset="5%" stopColor="#1976d2" stopOpacity={0.4} />
                                <stop offset="95%" stopColor="#1976d2" stopOpacity={0} />
                            </linearGradient>
                        </defs>

                        <CartesianGrid strokeDasharray="3 3" stroke="#e0e0e0" />
                        <XAxis dataKey="date" tick={{ fontSize: 12 }} />
                        <YAxis tick={{ fontSize: 12 }} />
                        <Tooltip content={<CustomTooltip />} />

                        {/* ТУТ рисуем линии начала недели */}
                        {proposalListByDate.map((entry, index) =>
                            entry.isWeekStart ? (
                                <ReferenceLine
                                    key={`week-start-${index}`}
                                    x={entry.date}
                                    stroke="#FF5722"
                                    strokeDasharray="3 3"
                                    label={{ value: '', angle: 0, position: 'inside', fontSize: 10, offset: -20 }}
                                />
                            ) : null
                        )}

                        <Area type="monotone" dataKey="sessions" stroke="#1976d2" fillOpacity={1} fill="url(#colorSessions)" />
                    </AreaChart>
                </ResponsiveContainer>
            </Card>

            {tableLoading && (
                <Box
                    sx={{
                        position: 'absolute',
                        top: 20,
                        left: 20,
                        right: 20,
                        bottom: 20,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        backdropFilter: 'blur(2px)',
                        backgroundColor: 'rgba(255,255,255,0.6)',
                        borderRadius: '16px',
                        zIndex: 2,
                    }}
                >
                    <CircularProgress/>
                </Box>
            )}
        </Box>

    );
}

const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
        return (
            <Box sx={{ backgroundColor: 'white', border: '1px solid #ccc', p: 1 }}>
                <Typography variant="body2">{label}</Typography>
                <Typography variant="body2">
                    <strong>proposals</strong>: {payload[0].value}
                </Typography>
            </Box>
        );
    }
    return null;
};



